import React, { FC } from "react";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { useDtpDetailModel } from "./dtpDetailModel";
import { RouterParamType } from "@/model/navModel";
import { IDtpTabEnum } from "../../dtpTypes";
import { BaseDetail } from "./base";
import { RelevanceTask } from "./task";
import { Files } from "./files";
import { CustomsClearance } from "./customsClearance";
import { Invoice } from "./invoice";
import { Encasement } from "./encasement";
import { AuditDetail } from "./audit";

export const TabBar: FC<RouterParamType> = (detailsInfo) => {
    const { tabActive, setTabActive, showDoc } = useDtpDetailModel(({ tabActive, showDoc }) => [tabActive, showDoc]);
    const isEdit = detailsInfo.mode === "edit";
    //防止保存是表单拿不到， 在下面渲染
    const RenderTabItem = () => {
        switch (tabActive) {
            case IDtpTabEnum.CUSTOMS_CLEARANCE:
                return <CustomsClearance {...detailsInfo} />;
            case IDtpTabEnum.INVOICE:
                return <Invoice {...detailsInfo} />;
            case IDtpTabEnum.ENCASEMENT:
                return <Encasement {...detailsInfo} />;
            case IDtpTabEnum.RELEVANCE_TASK:
                return <RelevanceTask {...detailsInfo} />;
            case IDtpTabEnum.FILES:
                return <Files {...detailsInfo} />;
            case IDtpTabEnum.AUDIT_DETAIL:
                return <AuditDetail {...detailsInfo} />;
            default:
                return <></>
        }
    }

    const classname = (type: IDtpTabEnum) => {
        return 'tab-item ' + (tabActive === type ? 'tab-active' : '')
    }
    const action = <>
        <Button
            className={classname(IDtpTabEnum.BASE_DETAIL)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IDtpTabEnum.BASE_DETAIL)}
        >基本信息</Button>
        {isEdit && <>
            <Button
                hidden={!showDoc.customs_clearance}
                className={classname(IDtpTabEnum.CUSTOMS_CLEARANCE)}
                type="link"
                shape="round"
                onClick={() => setTabActive(IDtpTabEnum.CUSTOMS_CLEARANCE)}
            >报关单</Button>
            {/* <Button
                hidden={!showDoc.invoice}
                className={classname(IDtpTabEnum.INVOICE)}
                type="link"
                shape="round"
                onClick={() => setTabActive(IDtpTabEnum.INVOICE)}
            >商业发票</Button>
            <Button
                hidden={!showDoc.encasement}
                className={classname(IDtpTabEnum.ENCASEMENT)}
                type="link"
                shape="round"
                onClick={() => setTabActive(IDtpTabEnum.ENCASEMENT)}
            >装箱单</Button> */}
            <Button
                className={classname(IDtpTabEnum.RELEVANCE_TASK)}
                type="link"
                shape="round"
                onClick={() => setTabActive(IDtpTabEnum.RELEVANCE_TASK)}
            >关联业务</Button>
            <Button
                className={classname(IDtpTabEnum.FILES)}
                type="link"
                shape="round"
                onClick={() => setTabActive(IDtpTabEnum.FILES)}
            >附件管理</Button>
            <Button
                className={classname(IDtpTabEnum.AUDIT_DETAIL)}
                type="link"
                shape="round"
                onClick={() => setTabActive(IDtpTabEnum.AUDIT_DETAIL)}
            >审批明细</Button>
        </>}
    </>

    return (
        <>
            <YhBox
                style={{ paddingBottom: 0, marginBottom: "10px" }}
                action={action}
            />
            <div hidden={tabActive !== IDtpTabEnum.BASE_DETAIL}><BaseDetail {...detailsInfo} /></div>
            <RenderTabItem />
        </>
    )
}